export default __webpack_public_path__ + "static/redsummit-f291a7bc5bcbcc3660f38db4664dd68a.png";